import { takeLatest, call, put, cancelled } from 'redux-saga/effects';
import Api from '../../Api';
import { GET_ORGANIZATIONS_FAIL, GET_ORGANIZATIONS_REQUEST, GET_ORGANIZATIONS_SUCCESS, GET_ORGANIZATIONS_CANCEL } from '../actions/organizations';

export default function* watcher() {
  yield takeLatest(GET_ORGANIZATIONS_REQUEST, getOrganizations);
}

function* getOrganizations(action) {
  const abortController = action.abortController;
  try {
    const { data } = yield call(Api.getOrganizations, action.payload, abortController ? { signal: abortController.signal } : {});

    yield put({
      type: GET_ORGANIZATIONS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      return;
    }
    
    console.warn(error, 'while getting organizations');

    let errorMessage = 'Unknown error';

    if (error.response) {
      errorMessage = error.response.data.message || 'Unknown server error';
    } else if (error.request) {
      errorMessage = 'No response from the server';
    } else {
      errorMessage = error.message || 'Unknown error';
    }

    yield put({
      type: GET_ORGANIZATIONS_FAIL,
      payload: errorMessage,
    });
  } finally {
    if (yield cancelled()) {
      if (abortController) {
        abortController.abort();
      }
    }
  }
}
